import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AdminSteps from '../common/AdminSteps';
import config from '../../config';
import {Row, Col, Table, Pagination} from 'react-bootstrap';
import * as runActions from '../../actions/runsActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import * as groupActions from '../../actions/groupActionCreators';
import * as courseActions from '../../actions/coursesActionCreators';
import * as commonActions from '../../actions/commonActions';
import Spinner from 'react-spinkit';
import label from '../../utils/lngEn';
import GroupForm from './GroupForm';
import { browserHistory } from 'react-router';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';
import AddStudentsModal from './AddStudentsModal';
import CustomPagination from '../common/CustomPagination';
import AddLocksModal from './AddLocksModal';
import RequirementRow from '../runs/RequirementRow';
import ConflictRow from '../runs/ConflictRow';
import AddGSRequirementModal from '../common/AddGSRequirementModal';
import AddGSConflictModal from '../common/AddGSConflictModal';


class GroupPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {

      groupDetails: {
        id: null
      },
      groupLoaded: false,
      showConfirmGroupDelete: false,
      groupStudents: [],
      groupStudentsList:[],
      startStudents: 0,
      endStudents: 10,
      activeStudentsPage: 1,
      email: {
        up: false,
        down: false,
        idle: true
      },
      identifier: {
        up: false,
        down: false,
        idle: true
      },
      base_budget: {
        up: false,
        down: false,
        idle: true
      },
      effective_budget: {
        up: false,
        down: false,
        idle: true
      },
      memberships: {
        up: false,
        down: false,
        idle: true
      },

      showAddStudentsModal: false,
      studentsModalValues: {
        title: '',
        initialValues: {}
      },
      coursesLoaded: false,
      showAddLocksModal: false,
      locksModalValues: {
        title: '',
        gsId: '',
        initialValues: {}
      },


      conflicts: [],
      requirements: [],
      startConf: 0,
      endConf: 10,
      startReq: 0,
      endReq: 10,
      activeConflictPage: 1,
      activeReqPage: 1,
      showConfModal: false,
      showReqModal: false,
      conflictModalValues: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict:false
        }
      },
      reqModalValues: {
        title: '',
        gsId: '',
        initialValues: {
          is_time_conflict:false
        }
      },

      showConfirmRestrictionDelete: false,
      deleteRestrictionId: '',
      deleteRestrictionType: '',
      confirmDeleteRestrictionTitle: '',
      confirmDeleteRestrictionMsg: ''
    };

    this.handleGroupFormSubmit = this.handleGroupFormSubmit.bind(this);
    this.closeDeleteGroupModal = this.closeDeleteGroupModal.bind(this);
    this.openDeleteGroupModal = this.openDeleteGroupModal.bind(this);
    this.handleDeleteGroup = this.handleDeleteGroup.bind(this);
    this.openStudentsModal = this.openStudentsModal.bind(this);
    this.closeAddStudentsModal = this.closeAddStudentsModal.bind(this);
    this.handleDeleteMembership = this.handleDeleteMembership.bind(this);

    this.handleStudentSearch = this.handleStudentSearch.bind(this);
    this.searchStudents = this.searchStudents.bind(this);
    this.setStudentsToState = this.setStudentsToState.bind(this);
    this.pageBack = this.pageBack.bind(this);
    this.pageForward = this.pageForward.bind(this);
    this.reorder = this.reorder.bind(this);
    this.sortByKeyAndDirection = this.sortByKeyAndDirection.bind(this);
    this.checkKey = this.checkKey.bind(this);
    this.getMembership = this.getMembership.bind(this);
    this.openLocksModal = this.openLocksModal.bind(this);
    this.closeAddLocksModal = this.closeAddLocksModal.bind(this);

    // Restrictions
    this.setRestrictionsToState = this.setRestrictionsToState.bind(this);
    this.handleRestrictionSearch = this.handleRestrictionSearch.bind(this);

    // Conflicts
    this.handleConflictPageChange = this.handleConflictPageChange.bind(this);
    this.openAddConflictModal = this.openAddConflictModal.bind(this);
    this.openEditConflictModal = this.openEditConflictModal.bind(this);
    this.closeAddConflictModal = this.closeAddConflictModal.bind(this);

    // Requirements
    this.openAddReqModal = this.openAddReqModal.bind(this);
    this.openEditReqModal = this.openEditReqModal.bind(this);
    this.closeAddReqModal = this.closeAddReqModal.bind(this);
    this.handleRequirementPageChange = this.handleRequirementPageChange.bind(this);

    // Delete Restriction
    this.showConfirmRestrictionDeleteModal = this.showConfirmRestrictionDeleteModal.bind(this);
    this.handleDeleteRestriction = this.handleDeleteRestriction.bind(this);
    this.closeDeleteModal = this.closeDeleteModal.bind(this);


  }
  componentWillMount() {
    if(!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if(this.props.groupId) {
      this.setState({groupLoaded: false});
      this.props.groupActions.getGroupById(this.props.groupId)
        .then(()=> {
          let group = Object.assign({},this.props.group);
          if(group.budget_adjustment) {
            group.budget_adjustment = group.budget_adjustment / 100;
          }
          this.setState({groupDetails: group});
          this.props.studentActions.getAllStudents();
          this.props.commonActions.getAllLocks(this.props.groupId, config.groups);
          this.props.commonActions.getAllGSRestrictions(this.props.groupId, config.groups,config.conflicts).catch(() => {
            console.log('conflicts rejected');
          });
          this.props.commonActions.getAllGSRestrictions(this.props.groupId, config.groups, config.requirements).catch(() => {
            console.log('requirements rejected');
          });
          this.props.courseActions.getAllCourses().then(()=>{
            if (this.refs.restrictions) {
              this.setState({coursesLoaded: true});
            }
          });
        });
      document.onkeydown = this.checkKey;
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.group.id || nextProps.group != this.props.group) {
      let group = Object.assign({}, nextProps.group);
      if(group.budget_adjustment) {
        group.budget_adjustment = group.budget_adjustment / 100;
      }
      this.setState({groupDetails: group, groupLoaded:true});
      if(nextProps.students != this.props.students) {
        this.setStudentsToState(this.props.group, nextProps.students);
      }

      if (this.props.group.conflicts != nextProps.group.conflicts) {
        this.setRestrictionsToState(nextProps.group.conflicts, config.conflicts);
      }
      if(this.props.group.requirements != nextProps.group.requirements) {
        this.setRestrictionsToState(nextProps.group.requirements, config.requirements);
      }
    }
    if(this.props.group.memberships && nextProps.group.memberships.length != this.props.group.memberships.length) {
      this.setStudentsToState(nextProps.group, this.props.students);
    }
    if (nextProps.courses != this.props.courses && nextProps.courses.length > 0) {
      this.setState({coursesLoaded: true});
      this.setRestrictionsToState(this.props.group.conflicts, config.conflicts);
      this.setRestrictionsToState(this.props.group.requirements, config.requirements);
    }
  }


  setStudentsToState(group, customStudentsArray) {
    let studentsIds = group.students;
    let newStudentsArray = [];
    studentsIds.forEach(studentId => {
      let studentsArray = customStudentsArray.filter( student => {
        return student.id == studentId;
      });
      if(studentsArray.length > 0) {
        newStudentsArray.push(studentsArray[0]);
      }
    });
    this.setState({groupStudents: newStudentsArray, groupStudentsList: newStudentsArray});
  }

  // Student form - Handle submit
  handleGroupFormSubmit(values) {
    if(typeof(values.budget_adjustment) == 'object') {
      values.budget_adjustment = values.budget_adjustment.value;
    }

    if(values.id) {
      this.props.groupActions.putGroup(values)
        .then(() => {
          this.props.groupActions.getGroupById(this.props.groupId);
          this.props.groupActions.getAllGroups();
          this.props.studentActions.getAllStudents();
          this.props.courseActions.getAllCourses().then(()=>{
            if (this.refs.restrictions) {
              this.setState({coursesLoaded: true});
            }
          });
        });
    } else {
      this.props.groupActions.createGroup(values)
        .then((res) => {
          this.props.groupActions.getGroupById(res.id)
            .then(() => {
              this.props.commonActions.getAllGSRestrictions(this.props.groupId, config.groups,config.conflicts).catch(() => {
                console.log('conflicts rejected');
              });
              this.props.commonActions.getAllGSRestrictions(this.props.groupId, config.groups, config.requirements).catch(() => {
                console.log('requirements rejected');
              });
              this.props.groupActions.getAllGroups();
              this.props.studentActions.getAllStudents();
              this.props.courseActions.getAllCourses().then(()=>{
                if (this.refs.restrictions) {
                  this.setState({coursesLoaded: true});
                }
              });
            });
          browserHistory.push('/administer/'+localStorage.getItem('run')+'/group/'+res.id);
        });
    }
  }

  // Group Modal
  openStudentsModal() {
    this.setState({
      showAddStudentsModal: true,
      studentsModalValues: {
        title: `${label.addStudentToGroup}`,
        groupId: this.props.groupId,
        initialValues: {
        }
      }
    });
  }
  closeAddStudentsModal() {
    this.setState({showAddStudentsModal: false});
  }

  // Delete Student
  openDeleteGroupModal() {
    this.setState({showConfirmGroupDelete: true});
  }
  handleDeleteGroup() {
    this.props.groupActions.deleteGroup(this.props.groupId)
      .then(() => {
        this.props.groupActions.getAllGroups();
        browserHistory.push('/administer/'+localStorage.getItem('run')+'/groups');
      });
  }
  closeDeleteGroupModal() {
    this.setState({showConfirmGroupDelete: false});
  }
  handleDeleteMembership(id) {
    if (id) {
      this.props.groupActions.deleteMembership(id)
        .then(() => {
          this.props.groupActions.getGroupById(this.props.group.id);
          this.props.groupActions.getAllGroups();
        });
    }
  }

  handleStudentSearch(e) {
    e.preventDefault();
    let term = e.target.value;
    if(term != '') {
      let arrUnique = this.searchStudents(term,this.state.groupStudents);

      this.setState({
        groupStudentsList:arrUnique,
        startStudents: 0,
        endStudents: 10,
        activeStudentsPage: 1
      });
    } else {
      // this.props.courseActions.getAllCourses();
      this.setStudentsToState(this.props.group, this.props.students);
    }
  }
  searchStudents(term, students) {
    let b = students.filter(student => {
      return student.user.email.toLowerCase().indexOf(term.toLowerCase()) != -1 ||
        student.identifier.toLowerCase().indexOf(term.toLowerCase()) != -1;
    });
    return b;
  }

  pageBack() {
    let newActivePage = this.state.activeStudentsPage -1;
    this.setState({activeStudentsPage: newActivePage});
    if(newActivePage == 1) {
      this.setState({startStudents: 0, endStudents: 10});
    } else {
      let start = newActivePage*10 - 10 ;
      let end = newActivePage*10;
      this.setState({startStudents: start, endStudents:end});
    }
  }
  pageForward() {
    let newActivePage = this.state.activeStudentsPage +1;
    this.setState({activeStudentsPage: newActivePage});
    let start = newActivePage*10 - 10 ;
    let end = newActivePage*10;
    this.setState({startStudents: start, endStudents:end});
  }

  checkKey(e) {
    if(this.refs.students) {
      e = e || window.event;
      if (e.keyCode == '37') {
        // left arrow
        if(this.state.activeStudentsPage > 1) {
          this.pageBack();
        }
      }
      else if (e.keyCode == '39') {
        // right arrow
        if(this.state.activeStudentsPage < Math.ceil(this.state.groupStudentsList.length/10)) {
          this.pageForward();
        }
      }
    }
  }

  // Ordering
  reorder(column) {
    if(this.state[column].idle) {
      this.setState({[column]:{
        up: true,
        down: false,
        idle: false
      }});
      let a = this.sortByKeyAndDirection(this.state.groupStudentsList, column, 'up');
      this.setState({groupStudentsList: a});
    } else if (this.state[column].up) {
      this.setState({[column]:{
        up: false,
        down: true,
        idle: false
      }});
      let a = this.sortByKeyAndDirection(this.state.groupStudentsList, column, 'down');
      this.setState({groupStudentsList: a});
    } else if (this.state[column].down) {
      this.setState({[column]:{
        up: true,
        down: false,
        idle: false
      }});
      let a = this.sortByKeyAndDirection(this.state.groupStudentsList, column, 'up');
      this.setState({groupStudentsList: a});
    }
    let obj = {
      email: {
        up: false,
        down: false,
        idle: true
      },
      identifier: {
        up: false,
        down: false,
        idle: true
      },
      base_budget: {
        up: false,
        down: false,
        idle: true
      },
      effective_budget: {
        up: false,
        down: false,
        idle: true
      },
      memberships: {
        up: false,
        down: false,
        idle: true
      }
    };

    delete obj[column];
    this.setState(obj);

    // Reset pagination
    this.setState({
      startStudents: 0,
      endStudents: 10,
      activeStudentsPage: 1
    });
  }

  sortByKeyAndDirection(array, key, direction) {
    if(key != 'email' && key != 'memberships') {
      return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        if(direction == 'up') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        } else if(direction == 'down') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
      });
    } else if (key == 'email') {
      return array.sort(function(a, b) {
        var x = a.user[key]; var y = b.user[key];
        if(direction == 'up') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        } else if(direction == 'down') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
      });
    } else if (key == 'memberships') {
      return array.sort(function(a, b) {
        var x = a.memberships.length;

        var y = b.memberships.length;
        if(direction == 'up') {
          return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        } else if(direction == 'down') {
          return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
      });
    }
  }

  handleEditStudent(student) {
    browserHistory.push('/administer/'+localStorage.getItem('run')+'/student/'+student.id);
  }
  getMembership(studentMemberships) {
    if (!studentMemberships) return null;

    let membership = studentMemberships.filter( m => {
      return m.group = this.props.group.id;
    });
    if(membership.length > 0) {
      return membership[0].id;
    }
  }

  handleDeleteLock(id) {
    this.props.commonActions.deleteLock(this.props.groupId, id, config.groups)
      .then(()=> {
        this.props.commonActions.getAllLocks(this.props.groupId, config.groups);
      });
  }

  // Locks Modal
  openLocksModal() {
    this.setState({
      showAddLocksModal: true,
      locksModalValues: {
        title: `${label.addLock}`,
        gsId: this.props.groupId,
        type: config.groups,
        initialValues: {
        }
      }
    });
  }
  closeAddLocksModal() {
    this.setState({showAddLocksModal: false});
  }


  // Add Requirement Modal
  openAddReqModal() {
    this.setState({
      showReqModal: true,
      reqModalValues: {
        title: `${label.createRequirement}`,
        gsId: this.props.groupId,
        type: config.groups,
        initialValues: {
        }
      }
    });
  }

  // Edit Requirement Modal
  openEditReqModal(req) {
    this.setState({
      showReqModal: true,
      reqModalValues: {
        title: `${label.editRequirement}`,
        gsId: this.props.groupId,
        type: config.groups,
        initialValues: {
          id: req.id,
          name: req.name,
          kind: req.kind.toString(),
          limit: req.limit.toString(),
          courses: req.courses
        }
      }
    });
  }
  closeAddReqModal() {
    this.setState({showReqModal: false})
  }

  // Handle Requirement page change
  handleRequirementPageChange(key) {
    this.setState({activeReqPage: key});
    if(key == 1) {
      this.setState({startReq: 0, endReq: 10});
    } else {
      let start = key*10 - 10 ;
      let end = key*10;
      this.setState({startReq: start, endReq:end});
    }
  }

  // Handle Restriction item Search
  handleRestrictionSearch(e, type) {
    e.preventDefault();
    let term = e.target.value;
    if(term != '') {
      let arrUnique = this.props.runActions.searchRestrictions(term,type == config.conflicts ? this.props.group.conflicts : this.props.group.requirements,this.props.courses);
      type == config.conflicts ? this.setState({conflicts:arrUnique,startConf: 0, endConf: 10, activeConflictPage: 1 }) : this.setState({requirements:arrUnique, startReq: 0, endReq: 10, activeReqPage: 1});
    } else {
      type == config.conflicts ? this.setState({conflicts:this.props.group.conflicts}) : this.setState({requirements: this.props.group.requirements});
    }
  }

  // Bind conflicts or requirements to local state
  setRestrictionsToState(restrictions, type) {
    if(type == config.conflicts) {
      this.setState({conflicts:restrictions});
    } else if (type == config.requirements) {
      this.setState({requirements: restrictions});
    }
  }


  // Confirm Delete Requirement Modal
  showConfirmRestrictionDeleteModal(id, type) {
    let item;
    if(type == config.conflicts) {
      item = this.state.conflicts.filter(r => {
        return r.id == id;
      });
    } else if (type == config.requirements) {
      item = this.state.requirements.filter(r => {
        return r.id == id;
      });
    }
    this.setState({deleteRestrictionId : id});
    this.setState({deleteRestrictionType: type});
    this.setState({showConfirmRestrictionDelete: true});
    this.setState({confirmDeleteRestrictionTitle: item[0].name});
    this.setState({confirmDeleteRestrictionMsg: `${type == config.conflicts ? label.deleteConfConfirmCustomMsg : label.deleteReqConfirmCustomMsg}`});
  }
  handleDeleteRestriction() {
    let c = this.state.deleteRestrictionId;
    if(c != '') {
      this.props.commonActions.deleteGSRestiction(this.props.groupId, this.state.deleteRestrictionId, config.groups, this.state.deleteRestrictionType);
    }
    this.setState({showConfirmRestrictionDelete: false});
  }
  closeDeleteModal() {
    this.setState({showConfirmRestrictionDelete: false});
  }

  // Handle Conflict page change
  handleConflictPageChange(key) {
    this.setState({activeConflictPage: key});
    if(key == 1) {
      this.setState({startConf: 0, endConf: 10});
    } else {
      let start = key*10 - 10 ;
      let end = key*10;
      this.setState({startConf: start, endConf:end});
    }
  }

  // Add Conflict Modal
  openAddConflictModal() {
    this.setState({
      showConfModal: true,
      conflictModalValues: {
        title: `${label.createConflict}`,
        gsId: this.props.groupId,
        type: config.groups,
        initialValues: {
          is_time_conflict: false
        }
      }
    });
  }

  // Edit Conflict Modal
  openEditConflictModal(conflict) {
    this.setState({
      showConfModal: true,
      conflictModalValues: {
        title: `${label.editConflict}`,
        gsId: this.props.groupId,
        type: config.groups,
        initialValues: {
          is_time_conflict: false,
          id: conflict.id,
          name: conflict.name,
          kind: conflict.kind.toString(),
          limit: conflict.limit.toString(),
          courses: conflict.courses
        }
      }
    });
  }
  closeAddConflictModal(){
    this.setState({showConfModal: false});
  }

  render() {
    const { assignment_complete } = this.props.run;

    return (
      <Col md={12}>
        <div className="page-title">Manage Group</div>
        <AdminSteps active="-1" label={this.props.run.slug}/>
        {this.props.groupId ?
          <button className="btn btn-ter pull-right delete-course" onClick={() => {this.openDeleteGroupModal()}}>Delete Group</button>
          : null}
        <Row>
          <Col md={12}>
            {this.props.groupId && this.state.groupDetails.id != null || !this.props.groupId ?
              <div>
                {this.props.groupId ?
                  null
                  : <div className="page-subtitle">Create New Group</div>}

                <Row>
                  <Col md={8}>
                    {this.props.groupId && this.props.group.id && this.state.groupLoaded ?
                      <GroupForm
                        onSubmit={this.handleGroupFormSubmit}
                        initialValues={this.state.groupDetails}
                        assignment_complete={assignment_complete}
                      />
                      : null}
                    {!this.props.groupId && !this.state.groupLoaded ?
                      <GroupForm
                        onSubmit={this.handleGroupFormSubmit}
                        initialValues={{budget_adjustment: 0}}
                        assignment_complete={assignment_complete}
                      /> : null}
                  </Col>
                </Row>
                {this.props.groupId ?
                  <div className="mt-4">
                    <div className="page-subtitle">Students in Group</div>
                    <Row className="mb-2">
                      <Col md={12}>
                        <Row>
                          <Col md={9}>
                            <div className="form-group search">
                              <span className="fa fa-search"></span>
                              <input
                                name="studentsSearchInput"
                                onChange={(e)=>{this.handleStudentSearch(e)}}
                                type="text"
                                className="form-control"
                                placeholder="Type email or identifier..."/>
                              <span className="input-description">Type email or identifier to filter students</span>
                            </div>
                          </Col>
                          <Col md={3}>
                            <button
                              type="button"
                              className="btn btn-block btn-ter"
                              onClick={()=> {this.openStudentsModal()}}
                              disabled={this.props.students.length == this.state.groupStudents.length}>{label.addStudentToGroup}</button>
                          </Col>
                        </Row>

                        <Row ref="students" className={this.props.group.students.length > 0 ? 'height480' : null}>
                          <Col  md={12}>
                            {this.props.group.students?
                              <div className="c-table classes-table">
                                {this.props.group.students.length > 0 ?
                                  <div>
                                  {this.props.students.length > 0 ?
                                    <div>

                                    <Table condensed hover>
                                      <thead>
                                      <tr>
                                        <th className="name" onClick={()=>{this.reorder('email')}}><span>Email address {this.state.email.up ? <i className="fa fa-sort-up"></i> : null}{this.state.email.down ? <i className="fa fa-sort-down"></i> : null} {this.state.email.idle ?<i className="fa fa-sort"></i> : null }</span></th>
                                        <th onClick={()=>{this.reorder('identifier')}}><span>Identifier {this.state.identifier.up ? <i className="fa fa-sort-up"></i> : null}{this.state.identifier.down ? <i className="fa fa-sort-down"></i> : null} {this.state.identifier.idle ?<i className="fa fa-sort"></i>: null }</span></th>
                                        { !assignment_complete && <th onClick={()=>{this.reorder('base_budget')}}><span>Base Budget {this.state.base_budget.up ? <i className="fa fa-sort-up"></i> : null}{this.state.base_budget.down ? <i className="fa fa-sort-down"></i> : null} {this.state.base_budget.idle ?<i className="fa fa-sort"></i>: null }</span></th> }
                                        { !assignment_complete && <th onClick={()=>{this.reorder('effective_budget')}}><span>Adjusted Budget {this.state.effective_budget.up ? <i className="fa fa-sort-up"></i> : null}{this.state.effective_budget.down ? <i className="fa fa-sort-down"></i> : null} {this.state.effective_budget.idle ?<i className="fa fa-sort"></i>: null }</span></th> }
                                        <th onClick={()=>{this.reorder('memberships')}}><span>Memberships {this.state.memberships.up ? <i className="fa fa-sort-up"></i> : null}{this.state.memberships.down ? <i className="fa fa-sort-down"></i> : null} {this.state.memberships.idle ?<i className="fa fa-sort"></i>: null }</span></th>
                                        <th></th>
                                        <th></th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                      {this.state.groupStudentsList.slice(this.state.startStudents, this.state.endStudents).map((student,index) => {
                                        return <tr key={index}>
                                          <td className="class-name"><span onClick={()=>{this.handleEditStudent(student)}}>{student.user.email}</span></td>
                                          <td className="class-desc">{student.identifier}</td>
                                          { !assignment_complete && <td className="class-desc">{student.base_budget/100}</td> }
                                          { !assignment_complete && <td className="class-desc">{student.effective_budget/100}</td>}
                                          <td className="class-desc">{student.memberships ? student.memberships.length : 0}</td>
                                          <td className="class-edit"><span onClick={()=>{this.handleEditStudent(student)}}>Edit</span></td>
                                          <td className="class-edit"><span onClick={()=>{this.handleDeleteMembership(this.getMembership(student.memberships))}}><i className="fa fa-minus-circle"></i></span></td>
                                        </tr>
                                      })}
                                      </tbody>
                                    </Table>


                                    <CustomPagination
                                      activePage={this.state.activeStudentsPage}
                                      onBack={this.pageBack}
                                      onForward={this.pageForward}
                                      listLength={Math.ceil(this.state.groupStudentsList.length/10)}/>
                                  </div>
                                      : <Spinner spinnerName="three-bounce"/>}
                                  </div>
                                  : <h3 className="text-center text-blue">There are no students in this group.</h3>}
                              </div>
                              :
                              <div className="spinner-box">
                                <h3 className="text-center mb-3">Depending on students number, this can take a while...</h3>
                                <Spinner spinnerName="three-bounce" className="mt-4"/>
                              </div>}

                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    {this.state.coursesLoaded ?
                      <div>
                        <div className="page-subtitle" ref="restrictions">{label.groupRestrictions}</div>
                        <Row className="mb-2 mt-n-2">
                          <Col md={12}>
                            <span className="subtitle">Locks</span>
                            <span className="add-new"><i onClick={()=>{this.openLocksModal()}} className="fa fa-plus-circle ml-1"></i></span>
                          </Col>
                        </Row>
                        {this.props.group.locks && this.props.group.locks.length > 0 && this.state.coursesLoaded ?
                          <div className="conflict-row no-span-links">
                            <div className="conflict-name">
                              <div className="name"><span className="no-span-links">Students Cannot Take:</span></div>
                            </div>
                            <div className="conflict-courses">
                              {this.props.group.locks.map((lock,index) => {
                                return (
                                  <div key={index} className="conflict-course"><span className="no-span-links">{commonActions.getCourseName(lock.course,this.props.courses)}</span>
                                    <span className="ml-1"><i className="fa fa-minus-circle" onClick={()=>{this.handleDeleteLock(lock.id)}}></i></span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          :null }


                        <Row className="mt-4">
                          <Col md={12}>
                            <span className="subtitle">Conflicts</span>
                            <span className="add-new"><i onClick={()=>{this.openAddConflictModal()}} className="fa fa-plus-circle ml-1"></i></span>
                          </Col>
                        </Row>
                        {this.props.group.conflicts.length > 0 ?
                          <Row>
                            <Col md={12}>
                              <div className="form-group mt-2 mb-2 restriction-search">
                                <span className="fa fa-search"></span>
                                <input
                                  name="conflictSearchInput"
                                  onChange={(e)=>{this.handleRestrictionSearch(e, config.conflicts)}}
                                  type="text"
                                  className="form-control"
                                  placeholder="Conflict Name, Course Name/Slug..."/>
                                <span className="input-description">Type conflict name, course slug or name to filter conflicts</span>
                              </div>
                              <Row>
                                <Col md={12}>
                                  <Pagination
                                    bsSize="small"
                                    items={Math.ceil(this.state.conflicts.length/10)}
                                    activePage={this.state.activeConflictPage}
                                    onSelect={this.handleConflictPageChange}/>
                                </Col>
                              </Row>
                              <div>
                                {this.state.conflicts.slice(this.state.startConf, this.state.endConf).map((conflict,index) => {
                                  return <ConflictRow
                                    key={index}
                                    c={conflict}
                                    courses={this.props.courses}
                                    onDelete={this.showConfirmRestrictionDeleteModal}
                                    handleEdit={this.openEditConflictModal}
                                  />
                                })}
                              </div>
                              <Row>
                                <Col md={12}>
                                  <Pagination
                                    bsSize="small"
                                    items={Math.ceil(this.state.conflicts.length/10)}
                                    activePage={this.state.activeConflictPage}
                                    onSelect={this.handleConflictPageChange}/>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                          : null}


                        <Row className="mt-4">
                          <Col md={12}>
                            <span className="subtitle">Requirements</span>
                            <span className="add-new"><i onClick={()=>{this.openAddReqModal()}} className="fa fa-plus-circle ml-1"></i></span>
                          </Col>
                        </Row>
                        {this.props.group.requirements.length > 0 ?
                        <Row>
                          <Col md={12}>
                            <div className="form-group mt-2 mb-2 restriction-search">
                              <span className="fa fa-search"></span>
                              <input
                                name="conflictSearchInput"
                                onChange={(e)=>{this.handleRestrictionSearch(e, config.requirements)}}
                                type="text"
                                className="form-control"
                                placeholder="Requirement Name, Course Name/Slug..."/>
                              <span className="input-description">Type requirement name, course slug or name to filter requirements</span>
                            </div>
                            <Row>
                              <Col md={12}>
                                <Pagination
                                  bsSize="small"
                                  items={Math.ceil(this.state.requirements.length/10)}
                                  activePage={this.state.activeReqPage}
                                  onSelect={this.handleRequirementPageChange}/>
                              </Col>
                            </Row>
                            <div>
                              {this.state.requirements.slice(this.state.startReq, this.state.endReq).map((requirement,index) => {
                                return <RequirementRow
                                  key={index}
                                  requirement={requirement}
                                  courses={this.props.courses}
                                  onDelete={this.showConfirmRestrictionDeleteModal}
                                  handleEdit={this.openEditReqModal}
                                />
                              })}
                            </div>
                            <Row>
                              <Col md={12}>
                                <Pagination
                                  bsSize="small"
                                  items={Math.ceil(this.state.requirements.length/10)}
                                  activePage={this.state.activeReqPage}
                                  onSelect={this.handleRequirementPageChange}/>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                          : null}
                      </div>
                      : <Spinner spinnerName="three-bounce" className="mt-4"/>}

                    <AddStudentsModal
                      closeModal={this.closeAddStudentsModal}
                      showModal={this.state.showAddStudentsModal}
                      onCancel={this.closeAddStudentsModal}
                      initial={this.state.studentsModalValues}
                    />
                  </div>
                  : null}
                {this.props.groupId && this.props.courses.length > 0 ?
                  <div>
                    <AddLocksModal
                      closeModal={this.closeAddLocksModal}
                      showModal={this.state.showAddLocksModal}
                      onCancel={this.closeAddLocksModal}
                      initial={this.state.locksModalValues}
                    />
                    <AddGSConflictModal
                      closeModal={this.closeAddConflictModal}
                      showModal={this.state.showConfModal}
                      onCancel={this.closeAddConflictModal}
                      initial={this.state.conflictModalValues}
                    />
                    <AddGSRequirementModal
                    closeModal={this.closeAddReqModal}
                    showModal={this.state.showReqModal}
                    onCancel={this.closeAddReqModal}
                    initial={this.state.reqModalValues}
                    />
                  </div>
                  : null}

              </div>
              : <Spinner spinnerName="three-bounce"/>}


          </Col>
        </Row>
        <ConfirmDeleteModal
          closeModal={this.closeDeleteGroupModal}
          showModal={this.state.showConfirmGroupDelete}
          onCancel={this.closeDeleteGroupModal}
          customTitle={this.props.group.name}
          customMsg={label.deleteGroupCustomMsg}
          confirmButtonTitle='Delete'
          onConfirm={this.handleDeleteGroup}
        />
        <ConfirmDeleteModal
          closeModal={this.closeDeleteModal}
          showModal={this.state.showConfirmRestrictionDelete}
          onCancel={this.closeDeleteModal}
          customTitle={this.state.confirmDeleteRestrictionTitle}
          customMsg={this.state.confirmDeleteRestrictionMsg}
          confirmButtonTitle='Delete'
          onConfirm={this.handleDeleteRestriction}
        />
      </Col>
    );
  }
}

GroupPage.propTypes = {
  //myProp: PropTypes.string.isRequired
};

function mapStateToProps(state, ownProps) {
  let groupId = null;
  if(ownProps.params.id) {
    groupId = ownProps.params.id;
  }
  return {
    run: state.run,
    groupId: groupId,
    studentId: null, // delete
    student: state.student, // delete
    students: state.students,
    groups: state.groups,
    group: state.group,
    courses: state.courses
  };
}

function mapDispatchToProps(dispatch) {
  return {
    runActions: bindActionCreators(runActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch),
    groupActions: bindActionCreators(groupActions, dispatch),
    courseActions: bindActionCreators(courseActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupPage);



// WEBPACK FOOTER //
// ./src/components/groups/GroupPage.js